"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _propTypes = require("prop-types");

var _Header = require("./Header.styles");

var _Tabs = _interopRequireDefault(require("../Tabs/Tabs"));

var _elements = require("../../styles/elements");

var Header = function Header(_ref) {
  var className = _ref.className,
      tabsData = _ref.tabsData,
      tabType = _ref.tabType,
      children = _ref.children,
      onTabChange = _ref.onTabChange,
      activeKey = _ref.activeKey,
      title = _ref.title,
      compact = _ref.compact,
      onGoBack = _ref.onGoBack;
  var hasTabs = tabsData && tabsData.length;
  var hasOnlyTitle = title && !children && !hasTabs; // If tabType is big, need minus 8px from horizontal paddings to align the first tab title with page content

  var shouldOffsetLeftPadding = hasTabs && tabType === 'big';
  return (0, _jsxRuntime.jsxs)("header", {
    css: [_Header.styles.base, compact && _Header.styles.compact, process.env.NODE_ENV === "production" ? "" : ";label:Header;"],
    className: (0, _clsx["default"])('grui flex flex-col pr-16', shouldOffsetLeftPadding ? 'pl-14' : 'pl-16', className),
    children: [(0, _jsxRuntime.jsxs)("div", {
      className: (0, _clsx["default"])('grui flex flex-no-wrap items-end mt-auto', compact && 'px-12'),
      children: [(0, _jsxRuntime.jsxs)("div", {
        className: "grui mr-auto overflow-x-auto",
        css: tabType === 'big' && _Header.styles.offsetInkbar,
        children: [title && (0, _jsxRuntime.jsx)("h4", {
          css: _elements.heading.styles.h4,
          className: (0, _clsx["default"])('grui', hasOnlyTitle ? 'mb-10' : 'mb-7'),
          children: title
        }), hasTabs && (0, _jsxRuntime.jsx)(_Tabs["default"], {
          tabs: tabsData,
          onChange: onTabChange,
          type: tabType,
          activeKey: activeKey,
          css: _Header.styles["".concat(tabType, "Tab")],
          className: (0, _clsx["default"])('grui', title && 'mt-9', tabType === 'small' && 'pb-5'),
          onGoBack: onGoBack
        })]
      }), (0, _jsxRuntime.jsx)("div", {
        css: _Header.styles.wrapper,
        className: "grui flex items-center mb-5 ml-10",
        children: children
      })]
    }), (0, _jsxRuntime.jsx)("div", {
      css: _elements.divider.styles.primary,
      role: "separator"
    })]
  });
};

Header.propTypes = {
  className: _propTypes.string,

  /**
   * Data for tabs
   */
  tabsData: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: _propTypes.string,
    tabName: _propTypes.string
  })),
  children: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),

  /**
   * Props for Tabs component
   */
  onTabChange: _propTypes.func,
  tabType: (0, _propTypes.oneOf)(['big', 'small']),
  activeKey: _propTypes.string,

  /**
   * Custom title
   */
  title: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node]),

  /**
   * Use the compact variation of the header
   */
  compact: _propTypes.bool,

  /**
   * Callback for handling go back:
   * if the function is passed, will show go back button
   */
  onGoBack: _propTypes.func
};
Header.defaultProps = {
  className: undefined,
  children: undefined,
  tabType: 'big',
  activeKey: undefined,
  tabsData: undefined,
  onTabChange: function onTabChange() {},
  title: undefined,
  compact: false,
  onGoBack: undefined
};
var _default = Header;
exports["default"] = _default;
//# sourceMappingURL=Header.js.map